import { splitLines } from './splitLines';

export const initLinks = () => {
    let links = document.querySelectorAll('a:not([class])');

    if (!links) {
        return false
    }

    links.forEach(link => {
        splitLines(link, '<span>', '</span>')
    })
}